import {Component, Input, OnInit} from '@angular/core';
import {AppointmentListItem} from '@app/shared/models/data/appointments/AppointmentListItem';
import {ParentCommsService} from '@app/shared/services/core/comms/parent-comms.service';
import {CurrentTimeService} from '@app/shared/services/helpers/current-time/current-time.service';
import {DateUtil} from '@app/shared/utils/dates/DateParsing.util';
import {getElapsedTime} from '@app/shared/utils/dates/DateTools.util';
import {hasValue} from '@app/shared/utils/helpers';
import {
  ConsultationPopupRibbonService
} from '@src/app/shared/services/core/consultation-popup/consultation-popup-ribbon.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { ThinButtonComponent } from '../../../../../shared/components/buttons/thin-button/thin-button.component';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-consult-start-stop-btn',
    templateUrl: './consult-start-stop-btn.component.html',
    styleUrls: ['./consult-start-stop-btn.component.scss'],
    standalone: true,
    imports: [ThinButtonComponent, IconComponent, UpperCasePipe, LocalizeTextPipe]
})

export class ConsultStartStopBtnComponent implements OnInit {
  startConsultIsDisabled = false;

  private appointmentValue: AppointmentListItem = null;

  loadingStopConsult$ = false;
  loadingNextConsultation$ = false;
  consultDisplayTime: string = null;

  appointmentStarted: boolean = false;

  private unsub = new Subject<void>();

  @Input() set appointmentRecordedStartTime(content: string) {
    if (hasValue(content)) {
      this.showElapsedConsultTime(content);
    }
  }

  @Input() set appointment(content: AppointmentListItem) {
    this.appointmentValue = content;

    this.appointmentStarted = hasValue(content.appointment.recordedStartTime) && !hasValue(content.appointment.recordedEndTime);
  }

  get appointment(): AppointmentListItem {
    return this.appointmentValue;
  }

  constructor(
    public consultationPopup: ConsultationPopupRibbonService,
    private parentCommsService: ParentCommsService,
    public currentTime: CurrentTimeService,
  ) {
  }

  ngOnInit(): void {
  }

  /**
   * stops the consultation
   */
  stopConsultation(): void {
    if (this.startConsultIsDisabled) {
      return;
    }

    this.loadingStopConsult$ = true;
    this.consultationPopup.stopActiveConsultation().then(_ => this.loadingStopConsult$ = false);
    this.parentCommsService.hangUpCall();
  }

  /**
   * starts a consultation
   */
  startConsultation(): void {
    if (this.startConsultIsDisabled) {
      return;
    }

    // load next consulation
    this.loadingNextConsultation$ = true;

    // make call
    this.consultationPopup.startConsultation(this.appointment).then(_ => {
      this.loadingNextConsultation$ = false;
    });
  }

  /**
   * shows the elapsed time for the appointment
   * @param recordedStartTime: string
   */
  showElapsedConsultTime(recordedStartTime: string): void {

    // set var to recordedStartTime from appoinment request
    const consultStartTime = DateUtil.UTCStringToDate(recordedStartTime);

    this.currentTime.time$.pipe(takeUntil(this.unsub)).subscribe((currentTime: Date) => {
      this.consultDisplayTime = getElapsedTime(consultStartTime, currentTime);
    });
  }
}
